import imageConstants from "~/util/imageConstants";

export const CONSTANTS = {
  trackOnNextTick: false,
  images: imageConstants,
  bookingHash: "booking",
  forms: {
    // Agent Enquiry Form
    enquiryAgent: {
      formId: "form-agent-enquire",
    },

    // General Enquiry Form
    enquiryGuest: {
      formId: "form-enquire",
    },

    // Newsletter Subscribe
    newsletter: {
      formId: "form-newsletter",
    },

    // Tour Enquiry Form
    tour: {
      formId: "form-tour-enquire",
    },

    // Booking Enquiry Form
    booking: {
      formId: "form-booking-enquiry",
    },

    // Retreat Enquiry Form
    retreat: {
      formId: "form-retreat-enquire",
    },
  }
};

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide("constants", CONSTANTS);
});
